var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    attrs: {
      "id": "app"
    }
  }, [_c('sidebar'), _c('router-view', {
    attrs: {
      "apps": _vm.apps
    }
  }), _c('v-footer', {
    staticStyle: {
      "z-index": "10"
    },
    attrs: {
      "app": ""
    }
  }, [_c('v-row', {
    staticClass: "flex-nowrap"
  }, _vm._l(_vm.collabs, function (collab, index) {
    return _c('v-col', {
      key: index
    }, [_c('v-img', {
      staticClass: "logo mx-auto",
      style: index == 1 ? 'margin-top: 10px;' : '',
      attrs: {
        "src": collab.logo,
        "contain": "",
        "max-height": "50",
        "max-width": index == 1 ? 100 : 200
      }
    })], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }